export interface ListSelectOptionModel {
  value: any;
  label?: string;
  hint?: string;
}

export interface ListSelectModel {
  formControlName?: string;
  required?: boolean;
  id?: string; // this goes into the template
  currentlyActiveOption?: number; //defaults to none. If you would like to select an item upon initial load of view pass in the option index.
  options?: ListSelectOptionModel[];
}

export const LIST_SELECT_DEFAULTS: ListSelectModel = {
  required: false,
};
